(() => {
  if (document.body.dataset.hnCustomilyPreviewModalReady) return;
  document.body.dataset.hnCustomilyPreviewModalReady = 'true';

  let trigger;
  let returnScrollY = 0;
  let decorateObserver;
  let restoringFocus = false;

  const modalIsOpen = (modal) => modal && getComputedStyle(modal).display !== 'none';

  const nativeAddButton = () => document.querySelector(
    '.product-form-buttons #customily-cart-btn, product-form-component #customily-cart-btn, #customily-cart-btn',
  );

  const restoreTrigger = () => {
    if (restoringFocus) return;
    restoringFocus = true;
    const started = performance.now();
    const waitForClose = () => {
      const modal = document.querySelector('.customily-modal-preview-only');
      if (!modalIsOpen(modal)) {
        requestAnimationFrame(() => {
          window.scrollTo({ top: returnScrollY, behavior: 'instant' });
          trigger?.focus({ preventScroll: true });
          restoringFocus = false;
        });
      } else if (performance.now() - started < 1500) {
        requestAnimationFrame(waitForClose);
      } else {
        restoringFocus = false;
      }
    };
    requestAnimationFrame(waitForClose);
  };

  const decorateModal = () => {
    const modal = document.querySelector('.customily-modal-preview-only');
    const panel = modal?.querySelector('.main');
    const nativeClose = panel?.querySelector('.customily-close-button');
    const media = panel?.querySelector('#preview-canvas, .cl-preview-wrapper img');
    const mediaWrapper = media?.closest('.canvas-wrapper, .cl-preview-wrapper');
    if (!modal || !panel || !nativeClose || !media || !mediaWrapper) return false;

    // The crossword controller owns render-readiness and Add-to-cart state.
    // Its runtime ownership marker is available before its modal markup, so
    // use that marker as well as the decorated header to avoid a click-order
    // race with this generic image/canvas shell.
    if (document.body.dataset.hnCustomilyCrosswordPreviewOwner === 'shared'
      || panel.querySelector('.hn-ui-preview__header')) return true;

    if (!nativeClose.dataset.hnCustomilyPreviewFocusReady) {
      nativeClose.dataset.hnCustomilyPreviewFocusReady = 'true';
      nativeClose.setAttribute('role', 'button');
      nativeClose.setAttribute('tabindex', '0');
      nativeClose.setAttribute('aria-label', 'Close preview');
      nativeClose.addEventListener('click', restoreTrigger);
      nativeClose.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        nativeClose.click();
      });
    }

    decorateObserver?.disconnect();

    if (panel.querySelector('.hn-customily-preview__header')) {
      const add = panel.querySelector('.hn-customily-preview__add');
      const nativeAdd = nativeAddButton();
      if (add) add.disabled = !nativeAdd || nativeAdd.disabled;
      panel.querySelector('.hn-customily-preview__close')?.focus();
      return true;
    }

    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'hn-customily-preview-title');
    panel.classList.add('hn-customily-preview');
    mediaWrapper.classList.add('hn-customily-preview__media');

    const header = document.createElement('div');
    header.className = 'hn-customily-preview__header';
    header.innerHTML = '<h2 id="hn-customily-preview-title">Looks Good to Go?</h2><p>Please double-check your preview before adding it to cart.</p>';

    const notes = document.createElement('div');
    notes.className = 'hn-customily-preview__notes';
    notes.innerHTML = '<p>Full refund for faulty production. No question asked</p><p>Your design will be saved with your order.</p>';

    const actions = document.createElement('div');
    actions.className = 'hn-customily-preview__actions';

    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'hn-customily-preview__add';
    add.textContent = 'Add to cart';
    const nativeAdd = nativeAddButton();
    add.disabled = !nativeAdd || nativeAdd.disabled;

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'hn-customily-preview__close';
    close.textContent = 'Close';

    close.addEventListener('click', () => {
      nativeClose.click();
      restoreTrigger();
    });
    add.addEventListener('click', () => {
      const currentNativeAdd = nativeAddButton();
      if (!currentNativeAdd || currentNativeAdd.disabled) return;
      nativeClose.click();
      requestAnimationFrame(() => currentNativeAdd.click());
    });

    if (nativeAdd) {
      new MutationObserver(() => { add.disabled = nativeAdd.disabled; }).observe(nativeAdd, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    actions.append(add, close);
    panel.insertBefore(header, nativeClose);
    panel.append(notes, actions);
    close.focus();
    return true;
  };

  document.addEventListener('click', (event) => {
    const nextTrigger = event.target?.closest?.('.customily-preview-button');
    if (!nextTrigger) return;
    trigger = nextTrigger;
    returnScrollY = window.scrollY;
    if (decorateModal()) return;
    decorateObserver?.disconnect();
    decorateObserver = window.HanossCustomilyCapabilities?.watchPreview(decorateModal);
  }, { capture: true });

  document.addEventListener('click', (event) => {
    const modal = event.target;
    if (!modal?.matches?.('.customily-modal-preview-only') || !modal.querySelector('.hn-customily-preview__header')) return;
    restoreTrigger();
  }, { capture: true });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('.customily-modal-preview-only');
    if (!modalIsOpen(modal) || !modal.querySelector('.hn-customily-preview__header')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      modal.querySelector('.customily-close-button')?.click();
      restoreTrigger();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [
      modal.querySelector('.customily-close-button'),
      modal.querySelector('.hn-customily-preview__add:not(:disabled)'),
      modal.querySelector('.hn-customily-preview__close'),
    ].filter(Boolean);
    if (!controls.length) return;
    event.preventDefault();
    const current = controls.indexOf(document.activeElement);
    const direction = event.shiftKey ? controls.length - 1 : 1;
    controls[(current + direction + controls.length) % controls.length].focus();
  }, { capture: true });
})();
